module.exports = __webpack_public_path__ + "media/images/icon_attention-fc600473723873a7d6d49710019de673.svg";